// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");

function makeStyle(angleOpt, color, opacityOpt, minX, minY, width, height, param) {
  var angle = angleOpt !== undefined ? angleOpt : 0;
  var opacity = opacityOpt !== undefined ? opacityOpt : 1;
  return {
          angle: angle,
          color: color,
          hover: undefined,
          opacity: opacity,
          minX: minX,
          minY: minY,
          width: width,
          height: height
        };
}

function makeAngleStyle(color, direction) {
  var angle = direction === "Top" ? 180 : (
      direction === "Down" ? 0 : (
          direction === "Left" ? 90 : -90
        )
    );
  return makeStyle(angle, color, undefined, 0, 0, 11, 8, undefined);
}

function makeIcon(icon) {
  if (typeof icon === "object") {
    var variant = icon.NAME;
    if (variant === "WRN" || variant === "WID" || variant === "STM" || variant === "STE" || variant === "OmU" || variant === "DOL" || variant === "ADU" || variant === "VO" || variant === "VF" || variant === "UT" || variant === "ST" || variant === "OV" || variant === "HD" || variant === "DE" || variant === "BW" || variant === "AD" || variant === "MegaPhone") {
      return makeStyle(undefined, icon.VAL, undefined, 0, 0, 32, 32, undefined);
    }
    if (variant === "Search" || variant === "Checked") {
      return makeStyle(undefined, icon.VAL, undefined, 0, 0, 32, 32, undefined);
    }
    if (variant === "Facebook") {
      if (icon.VAL === "Footer") {
        return makeStyle(undefined, undefined, 0.6, 0, 0, 8, 18, undefined);
      } else {
        return makeStyle(undefined, undefined, undefined, 0, 0, 8, 18, undefined);
      }
    }
    if (variant === "MessageClose") {
      return makeStyle(undefined, Belt_Option.getWithDefault(icon.VAL, "Black"), undefined, 0, 0, 32, 32, undefined);
    }
    if (variant === "Restriction18" || variant === "Restriction16" || variant === "Restriction12") {
      return makeStyle(undefined, icon.VAL, undefined, 0, 0, 500, 500, undefined);
    }
    if (variant === "Huawei") {
      return makeStyle(undefined, undefined, undefined, -20, 125, 940, 5, undefined);
    }
    if (variant === "Instagram") {
      if (icon.VAL === "Header") {
        return makeStyle(undefined, undefined, undefined, 0, 0, 17, 17, undefined);
      } else {
        return makeStyle(undefined, undefined, 0.6, 0, 0, 17, 17, undefined);
      }
    }
    if (variant === "CircleCheck") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 16, 16, undefined);
    }
    if (variant === "Twitter") {
      if (icon.VAL === "Footer") {
        return makeStyle(undefined, undefined, 0.6, 0, 0, 22, 18, undefined);
      } else {
        return makeStyle(undefined, undefined, undefined, 0, 0, 22, 18, undefined);
      }
    }
    if (variant === "Tv") {
      return makeStyle(undefined, icon.VAL, undefined, 0, 0, 26.67, 20, undefined);
    }
    if (variant === "Youtube") {
      if (icon.VAL === "Header") {
        return makeStyle(undefined, undefined, undefined, 0, 0, 21, 16, undefined);
      } else {
        return makeStyle(undefined, undefined, 0.6, 0, 0, 21, 16, undefined);
      }
    }
    if (variant === "Angle") {
      var match = icon.VAL;
      return makeAngleStyle(match[1], match[0]);
    }
    if (variant === "Seek") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 36, 32, undefined);
    }
    if (variant === "Heart") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 27, 25, undefined);
    }
    
  } else {
    if (icon === "MenuConcert") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 25, 26, undefined);
    }
    if (icon === "MapMarker" || icon === "Calendar") {
      return makeStyle(undefined, "Arte", undefined, 0, 0, 32, 32, undefined);
    }
    if (icon === "Twitch") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 22, 25, undefined);
    }
    if (icon === "TeaserPlay") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 40, 40, undefined);
    }
    if (icon === "Info" || icon === "Download") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 20, 20, undefined);
    }
    if (icon === "Desktop") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 23.85, 20, undefined);
    }
    if (icon === "CloseWithBackground" || icon === "RectClose") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 22, 22, undefined);
    }
    if (icon === "Plus" || icon === "Error") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 16, 16, undefined);
    }
    if (icon === "Share") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 18, 26, undefined);
    }
    if (icon === "SmartPhone") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 10.97, 20, undefined);
    }
    if (icon === "PlayerPlay") {
      return makeStyle(undefined, "White", 1, 0, 0, 17, 17, undefined);
    }
    if (icon === "Tablet") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 16.77, 20, undefined);
    }
    if (icon === "Menu") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 20, 15, undefined);
    }
    if (icon === "Whatsapp") {
      return makeStyle(undefined, undefined, undefined, -285, 410.5, 24.4, 21.4, undefined);
    }
    if (icon === "Play") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 15, 17, undefined);
    }
    if (icon === "User") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 26, 25, undefined);
    }
    if (icon === "Arrow") {
      return makeStyle(undefined, undefined, undefined, 0, 0, 507.36, 507.36, undefined);
    }
    
  }
  return makeStyle(undefined, undefined, undefined, 0, 0, 32, 32, undefined);
}

function view(param) {
  return {
          viewBox: "" + param.minX.toString() + " " + param.minY.toString() + " " + param.width.toString() + " " + param.height.toString() + ""
        };
}

exports.makeStyle = makeStyle;
exports.makeAngleStyle = makeAngleStyle;
exports.makeIcon = makeIcon;
exports.view = view;
/* No side effect */
